/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { replacePXinStringWithEM, boxShadow, animations } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EDITABLE TEXT : STYLES --------------- ++++++++++ */
export default theme => ({
    editabletextwrapper: {
        width: '100%',
        height: 'auto',
        '& .editabletext': {
            border: 'none',
            // overflow: 'auto',
            outline: 'none',
            boxShadow: 'none',
            background: 'transparent',
            resize: 'none',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            textAlign: 'inherit',
            color: 'inherit',
            width: '100%',
            height: 'auto',
            transition: 'box-shadow .2s linear 0s',
            overflow: 'hidden',
            whiteSpace: 'normal',
            cursor: 'text',
            '&:empty:not(:focus):before': {
                content: 'attr(data-text)'
            }
        },
        '& .charactercount': {
            position: 'absolute',
            left: '-1px',
            top: '-14px',
            fontSize: '10px',
			fontWeight: 600,
			opacity: 0,
            transition: 'opacity 0.2s linear, color .2s linear',
            '&.limit-approaching': {
            	color: '#ffae22'
			},
            '&.limit-reached': {
            	color: '#DF1D1B'
            }
        },

        '&:focus-within': {
            '& .charactercount': {
                visibility: 'visible',
				opacity: 1,
            }
        }

	}

});
